import { render, staticRenderFns } from "./LgsProvider.vue?vue&type=template&id=32391a80&"
import script from "./LgsProvider.vue?vue&type=script&lang=js&"
export * from "./LgsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports